// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__31yge","header":"ReportDetails_header__2uxF9","title":"ReportDetails_title__1Fdsp","left":"ReportDetails_left__3-5Eo"};